import { render, staticRenderFns } from "./UploadPointInfo.vue?vue&type=template&id=328bce9d&"
import script from "./UploadPointInfo.vue?vue&type=script&lang=js&"
export * from "./UploadPointInfo.vue?vue&type=script&lang=js&"
import style0 from "./UploadPointInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports